module.exports = __webpack_public_path__ + "cf60d5d5d04ba4062cc9bd8bde62d3b3.svg";